import { Fragment, useEffect, useState, memo } from 'react';
import { css } from 'twin.macro';
import { connect, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { eventTypeContainer } from '../../GeoLocation';
import CreateEvent from './CreateEvent';
import { LoadingSpinner } from '@/_elements/Loaders';
import { fetchWrapper } from '@/_helpers';
import { getTheTask, setUpcomingTaskList as setUpcomingTasksList } from '@/_redux/actions/ActionTasks';
import EventTypePreview from '@/components/Features/Events/EventTypePreview';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import EventModalFromUrl from '@/components/Features/Events/EventModalFromUrl';
import UserActivityAvatar from './UserActivityAvatar';

const Component = memo(({ ui, upcomingTaskList: upcomingTaskListRedux, showCreateEvent, toggleCreateEvent }) => {
    const [upcomingTaskList, setUpcomingTaskList] = useState(null);
    const [activeEvent, setActiveEvent] = useState({});
    const [showModal, setShowModal] = useState(null);
    const [isBusy, setIsBusy] = useState(false);
    const dispatch = useDispatch();
    const [nowTick, setNowTick] = useState(Date.now());

    const fetchUpcomingTasks = async () => {
        try {
            const response = await fetchWrapper.get(`/task/me/upcoming?date=${new Date().toISOString()}&limit=5`);
            dispatch(setUpcomingTasksList(response?.results || []));
            setUpcomingTaskList(response?.results || []);
        } catch (error) {
            if (error?.name === 'AbortError') return;
            toast.error(error.message);
            setUpcomingTaskList([]);
        }
    };

    useEffect(() => {
        fetchUpcomingTasks();
    }, []);

    useEffect(() => {
        const id = setInterval(() => setNowTick(Date.now()), 30000);
        return () => clearInterval(id);
    }, []);

    useEffect(() => {
        setUpcomingTaskList(upcomingTaskListRedux);
    }, [upcomingTaskListRedux]);

    const handleClosed = () => {
        setShowModal(null);
        setActiveEvent({});
    };

    const handleShowEvent = async (event) => {
        try {
            setIsBusy(true);
            const id = event?._id || event?.id;
            setShowModal(id);
            setActiveEvent(event);
        } catch (error) {
            toast.error(error?.message);
        } finally {
            // setIsBusy(false);
        }
    };

    const handleShowExternalEvent = (task) => {
        setShowModal(task?._id);
        setActiveEvent(task);
    };

    const handleEventClick = (task) => {
        if (task?.externalEvent) {
            handleShowExternalEvent(task);
        } else {
            handleShowEvent(task);
        }
    };

    const handleRemoveActive = () => {
        setActiveEvent({});
    };

    return (
        <div css={eventTypeContainer}>
            {/* {showModal && showModal === activeEvent?._id && (
                <PreviewEventModal data={activeEvent} handleClose={handleClosed} />
            )} */}
            {showModal && showModal === activeEvent?._id && (
                <EventModalFromUrl taskID={activeEvent?._id} onClose={handleClosed} setIsBusy={setIsBusy} />
            )}
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 12px;
                    width: 100%;
                `}
            >
                <UserActivityAvatar />

                {ui?.loading || !upcomingTaskList ? <LoadingSpinner /> : <Fragment></Fragment>}

                {[...(upcomingTaskList || [])]
                    .sort(
                        (a, b) =>
                            new Date(a?.demandDate || a?.latestDatePointer) -
                            new Date(b?.demandDate || b.latestDatePointer)
                    )
                    .map((task, index) => (
                        <EventTypePreview
                            key={task?._id || task?.id || index}
                            task={task}
                            index={index}
                            isBusy={isBusy}
                            showModal={showModal}
                            activeEvent={activeEvent}
                            nowTick={nowTick}
                            onEventClick={handleEventClick}
                            onRemoveActive={handleRemoveActive}
                        />
                    ))}

                <CreateEvent
                    fetchUpcomingTasks={fetchUpcomingTasks}
                    createButtonStyle={{
                        width: '80px !important',
                        height: '80px !important',
                        borderRadius: '50% !important',
                    }}
                    showCreateEvent={showCreateEvent}
                    toggleCreateEvent={toggleCreateEvent}
                />
            </div>
        </div>
    );
});

const mapStateToProps = (state) => ({
    ui: state.ui,
    user: state.user.user,
    upcomingTaskList: (state.tasks || {}).upcomingTaskList,
});

const UpcomingEvents = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
        <Component {...props} />
    </ComponentErrorBoundary>
);
export default connect(mapStateToProps, {
    getTheTask,
})(UpcomingEvents);
